import React from 'react';
import { Checkbox } from '@prisjakt/ui-inputs';
import * as S from './styles';
import { IQuickPriceFilter } from '../types';

const QuickPriceFilters: React.FC<IQuickPriceFiltersProps> = props => {
  if (!Array.isArray(props.priceFilters)) {
    return null;
  }
  return (
    <>
      {props.priceFilters.map(priceFilter => {
        return (
          <S.QuickPriceFilter
            key={priceFilter.name}
            data-test="QuickPriceFilter"
            className={props.className}
          >
            <Checkbox
              name={priceFilter.name}
              checked={priceFilter.checked}
              onChange={props.onFilterChanged}
              label={priceFilter.label}
            />
          </S.QuickPriceFilter>
        );
      })}
    </>
  );
};

interface IQuickPriceFiltersProps {
  className?: string;
  priceFilters: IQuickPriceFilter[];
  onFilterChanged: any;
}

export default QuickPriceFilters;
